import { TypePolicies } from '@apollo/client';

import { Query_Root } from '@eluve/graphql-types';

import { CapitalizeKeys, TypeSafePolicies } from './types';

export const typeSafePolicies = {
  AppointmentDoctorInteractions: {
    keyFields: ['appointmentId'],
  },
  TenantFeatureFlags: {
    keyFields: ['tenantId', 'flag'],
  },
  TenantLlmOutputs: {
    keyFields: ['tenantId', 'llmOutputName'],
  },
  TenantUsers: {
    keyFields: ['tenantId', 'userId'],
  },
  Locations: {
    fields: {
      location_users: {
        merge: (_existing = [], incoming) => [...incoming],
      },
    },
  },
  LocationUsers: {
    keyFields: ['locationId', 'userId'],
  },
  AppointmentFiles: {
    keyFields: ['appointmentId', 'fileId'],
  },
  UserSettings: {
    keyFields: ['userId'],
  },
  AppointmentHumanOutputs: {
    keyFields: ['humanOutputId'],
  },
  InheritedLocationFeatureFlags: {
    keyFields: ['locationId', 'flag'],
  },
  InheritedLocationLogos: {
    keyFields: ['locationId'],
  },
  TenantMedicalCodeTypes: {
    keyFields: ['tenantId', 'codeTypeName'],
  },
  TenantPromptTemplates: {
    keyFields: ['tenantId', 'promptTemplateId'],
  },
  TenantLlmOutputTemplates: {
    keyFields: ['tenantId', 'llmOutputTemplateId'],
  },
  GlobalFeatureFlagsStatus: {
    keyFields: ['flag'],
  },
  TenantUserSettings: {
    keyFields: ['tenantId', 'userId'],
  },
  TenantUserChatSettings: {
    keyFields: ['tenantId', 'userId'],
  },
  DefaultTenantUserSettings: {
    keyFields: ['tenantId'],
  },
  AppointmentBillingCodes: {
    fields: {
      linked_codes: {
        merge: (_existing = [], incoming) => [...incoming],
      },
    },
  },
  BillingCodeLocationPrices: {
    keyFields: ['tenantId', 'locationId', 'billingCodeId'],
  },
  TenantReviewers: {
    keyFields: ['tenantId', 'userId'],
  },
  AppointmentOutputArtifacts: {
    keyFields: ['tenantId', 'id'],
  },
  PromptTemplateVariants: {
    keyFields: ['promptTemplateId', 'variantNumber'],
  },
  LlmOutputTemplateVariants: {
    keyFields: ['outputTemplateId', 'variantNumber'],
  },
  LlmOutputsMetadata: {
    keyFields: ['llmOutputId'],
  },
  Utterances: {
    fields: {
      fragments: {
        merge: (_existing = [], incoming) => [...incoming],
      },
    },
  },
  AppointmentSegments: {
    fields: {
      utterances: {
        merge: (_existing = [], incoming) => [...incoming],
      },
    },
  },
  Appointments: {
    fields: {
      appointment_llm_jobs: {
        merge: (_existing = [], incoming) => [...incoming],
      },
    },
  },
} satisfies TypeSafePolicies<CapitalizeKeys<Query_Root>>;

export const typePolicies = {
  query_root: { queryType: true },
  muation_root: { mutationType: true },
  ...typeSafePolicies,
} as TypePolicies;
